









import { Component, Vue } from "vue-property-decorator";
import user from "../store/modules/user";
import EditOrganization from "@/components/organization/edit-organization.vue";
import { IOrganization } from "@/interfaces/organization.interface";

@Component({
  components: { EditOrganization }
})
export default class ManageOrganizationView extends Vue {
  created(): void {
    user.refreshOwnOrganization();
  }

  async onEditedOrganization(orga: IOrganization) {
    await user.updateOrganization(orga);
    user.refreshOwnOrganization();
  }

  get organization(): IOrganization | null {
    return user.organization;
  }
}
